import { registerPlugins } from '@/plugins'
import App from './App.vue'
import { createApp } from 'vue'
import * as Sentry from "@sentry/vue";
import packageInfo from '../package.json'

const app = createApp(App)
// Sentry configuration
Sentry.init({
  app,
  environment: import.meta.env.VITE_APP_ENV || "development",
  release: `${packageInfo.name}@${packageInfo.version}`,
  dsn: import.meta.env.VITE_SENTRY_DSN
});

registerPlugins(app)

app.mount('#app')
